const signedDefaultPermissions = [
    {
        link: '/dashboard'
    },
    {
        link: '/grupo_permissoes/:grupoId'
    },
    {
        link: '/perfil'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/relatorio/:grupoId'
    },
    {
        link: '/gerenciar/:entidade'
    },
    {
        link: '/evento/:id'
    },
    {
        link: '/atendimento/:id'
    },
    {
        link: '/processos/:processo_id'
    },
    {
        link: '/enquete/:id/votar'
    },
    {
        link: '/enquete/:id/feedback'
    },
    {
        link: '/enquete/:id/respostas'
    },
    {
        link: '/enquete/participacao'
    },
    {
        link: '/checkout_auth/:fatura_id'
    },
    {
        link: '/checkout_auth_iframe/:fatura_id'
    },
    {
        link: '/codigo_etica/redirect'
    },
    {
        link: '/auth/codigo_etica'
    }
]

const unsignedDefaultPermissions = [
    {
        link: '/'
    },
    {
        link: '/signup'
    },
    {
        link: '/associacao'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/pass_recover'
    },
    {
        link: '/pass_recover/:token/:crm'
    },
    {
        link: '/matricula_recover'
    },
    {
        link: '/compra_cartao'
    },
    {
        link: '/evento/:id/:pessoa_id'
    },
    {
        link: '/evento/:id/painel'
    },
    {
        link: '/consulta_publica'
    },
    {
        link: '/atendimento/feedback/:token'
    },
    {
        link: '/processo/feedback/:token'
    },
    {
        link: '/documentos/:id'
    },
    {
        link: '/certificado'
    },
    {
        link: '/visita/feedback/:token'
    },
    {
        link: '/publicacao/publico'
    },
    {
        link: '/socket'
    },
    {
        link: '/fatura_paga'
    },
    {
        link: '/atendimento'
    },
    {
        link: '/admin_tasks'
    },
    {
        link: '/evento/publico'
    },
    {
        link: '/checkout/:fatura_id'
    },
    {
        link: '/eleicao/verificacao/:id'
    },
    {
        link: '/convite_associacao'
    },
    {
        link: '/codigo_etica/redirect'
    },
    {
        link: '/codigo_etica'
    }
]

export {
    unsignedDefaultPermissions,
    signedDefaultPermissions
}
